/**
 * Owner: Masa Bayu
 * File: id.ts
 * Date:Time: 2026-09-15 19:18
 * Description: Stable identity helpers for QXRead foundation objects.
 */
export function createQxreadId(prefix) {
    return `${prefix}_${crypto.randomUUID()}`;
}
//# sourceMappingURL=id.js.map